import React from 'react'

export const Bubble = () => {
  return <div className='bubble-inner'></div>
}
